import React from 'react';
import SectionNavLinks from './SectionNavLinks';

const MobileTabBar: React.FC = () => (
  <nav className="mobile-tab-bar" aria-label="Section navigation">
    <SectionNavLinks
      className="mobile-tab-bar-links"
      linkClassName="mobile-tab-bar-link"
      showLabels
      iconSize={20}
    />
  </nav>
);

export default MobileTabBar;
